import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import { rqtGetCustomerDetail } from '@/services/cms/customer';
import { rqtGetPlace } from '@/services/common/place';
import { rqtPostUserPrivilegeWechatLogout } from '@/services/common';
import { mapGetters } from 'vuex';
import { removeAuthorization } from '@/utils/request';
import { ls } from '@/utils/aes';
import { showConfirmDialog } from 'vant';
export default {
  components: {
    PageNavBackLayoutCpt
  },
  data() {
    return {
      addFlag: true,
      customerDetail: {},
      customerAddress: {
        pcc: '',
        street: ''
      }
    };
  },
  computed: {
    getAddr() {
      return this.customerAddress.pcc + (this.customerAddress.street || '');
    },
    ...mapGetters('account', ['user'])
  },
  mounted() {
    rqtGetCustomerDetail({
      id: this.user.customerId
    }).then(res => {
      const resData = res.data.data;
      this.customerDetail = resData.customerDetail;
      if (resData.customerAddressList && resData.customerAddressList.length) {
        const defaultAddr = resData.customerAddressList.find(e => e.isDefault === 'Y') || resData.customerAddressList[0];
        this.formatAddr(defaultAddr);
      }
    }).catch(() => {});
  },
  methods: {
    async formatAddr(addr) {
      if (addr.province) {
        await Promise.all([rqtGetPlace({
          placeType: '01',
          placeCode: addr.province
        }), rqtGetPlace({
          placeType: '02',
          placeCode: addr.city
        }), rqtGetPlace({
          placeType: '03',
          placeCode: addr.country
        })]).then(([res1, res2, res3]) => {
          const resData1 = res1.data.data;
          const resData2 = res2.data.data;
          const resData3 = res3.data.data;
          addr.pcc = [resData1.placeName, resData2.placeName, resData3.placeName].join('');
          this.customerAddress = addr;
        }).catch(() => {});
      }
    },
    onLogoutClick() {
      showConfirmDialog({
        title: '提示',
        message: '确定这样做嘛？'
      }).then(() => {
        this.logout();
      }).catch(() => {});
    },
    logout() {
      rqtPostUserPrivilegeWechatLogout({
        userId: this.user.userId
      }).then(() => {
        localStorage.removeItem(process.env.VUE_APP_ROUTES_KEY);
        localStorage.removeItem(process.env.VUE_APP_PERMISSIONS_KEY);
        localStorage.removeItem(process.env.VUE_APP_ROLES_KEY);
        localStorage.removeItem(process.env.VUE_APP_USER_KEY);
        ls.removeAll();
        removeAuthorization();

        // this.$router.replace('/wx/login')
        window.location.href = process.env.VUE_APP_WECHAT_LOGIN_URL;
        /* setTimeout(() => {
          location.reload()
        }, 300) */
      }).catch(() => {});
    }
  }
};